import { useLogoutListener } from '@/features/Listeners/hooks/useLogoutListener';

const Listeners = () => {
  useLogoutListener();
  return null;
};

export default Listeners;
